import { Component, Input, OnInit, OnChanges, ChangeDetectionStrategy } from '@angular/core';

import { Dimensions } from '../models/dimensions.type';

@Component({
    selector: 'aa-chart',
    templateUrl: './chart.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ChartComponent implements OnInit, OnChanges
{
    @Input() title: string;
    @Input() dimensions: Dimensions;
    public transform: string;
    public viewBox: string;

    ngOnInit (): void
    {
        this.update();
    }

    ngOnChanges (): void
    {
        this.update();
    }

    private update ()
    {
        this.transform = `translate(${this.dimensions.marginLeft}px, ${this.dimensions.marginTop}px)`;
        this.viewBox = `0 0 ${this.dimensions.width} ${this.dimensions.height}`;
    }
}
